import { api } from '@/api/client';
import { quotaStore } from '@/access/quotaStore';
import { normalizeVideo } from '@/api/normalize/video';
import type {
  FilterOptionsResponse,
  SearchClickPayload,
  VideoListParams,
  VideoListResponse,
  VideoShowResponse,
} from '@/api/types';

/** Сериализация параметров в формате Laravel: массивы как `key[]=v`. */
export function toQueryString(params: VideoListParams): string {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined || value === null || value === '' || value === false) continue;
    if (Array.isArray(value)) {
      if (value.length === 0) continue;
      for (const item of value) query.append(`${key}[]`, String(item));
    } else if (value === true) {
      query.set(key, 'true');
    } else {
      query.set(key, String(value));
    }
  }
  return query.toString();
}

export const catalogApi = {
  /** Страницы 2+ несут X-Search-Event-Id — показы одной выдачи склеиваются в один поиск (CAT-15). */
  list: async (params: VideoListParams, searchEventId?: number | null, signal?: AbortSignal) => {
    const response = await api.get<VideoListResponse>(
      `/video-references?${toQueryString(params)}`,
      {
        ...(searchEventId ? { headers: { 'X-Search-Event-Id': String(searchEventId) } } : {}),
        signal,
      },
    );
    return { ...response, data: response.data.map(normalizeVideo) };
  },

  show: async (id: number) => {
    const response = await api.get<VideoShowResponse>(`/video-references/${id}`);
    quotaStore.set(response.quota);
    return { ...response, data: normalizeVideo(response.data) };
  },

  filterOptions: () => api.get<FilterOptionsResponse>('/filter-options'),

  /** Клик по результату поиска — fire-and-forget. */
  trackSearchClick: (payload: SearchClickPayload) => {
    api.post('/search/click', payload).catch(() => {});
  },
};
